export default function registerServiceWorker() {
  return new Promise((resolve, reject) => {
      if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
          navigator.serviceWorker.register('/serviceWorker.js')
          .then(registration => {
              console.log('ServiceWorker registration successful with scope: ', registration.scope);
              
              if (registration.installing) {
              // Wait for the installing service worker to finish
              registration.installing.addEventListener('statechange', function(e) {
                  if (e.target.state === 'activated') {
                  // If the new service worker is activated, resolve the promise
                  resolve();
                  }
              });
              } else if (navigator.serviceWorker.controller) {
              // The page is already controlled, resolve the promise
              resolve();
              } else {
              // Wait for a new service worker to control the page
              navigator.serviceWorker.addEventListener('controllerchange', () => {
                  resolve();
              });
              }
          })
          .catch(error => {
              console.error('ServiceWorker registration failed: ', error);
              reject(error);
          });
      });
      } else {
      reject("Service Worker is not supported in this browser.");
      }
  });
}